import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { BasicInfoDataType } from '../../../../models/dashboard/settings/profileSettings/basicInformation.model';
import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../../../models/https';
// import { useAppSelector } from '../../../../redux/store'
import useHttps from '../../../useHttps';
import useGetUserData from '../useGetUserData';

const useUpdateBasicInformation = () => {
  // const { authData } = useAppSelector((state) => state.auth);
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const { getUserData } = useGetUserData();

  const onUpdateBasicInfoError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(
      err?.response?.data?.message ??
        'Something went wrong while updating basic information'
    );
  };

  const onUpdateBasicInfoSuccess = ({
    data,
    message,
  }: SuccessHttpResponse<any>) => {
    toast.success(message);
    getUserData();
  };

  const updateBasicInfo = (data: BasicInfoDataType) => {
    const formData = new FormData();

    // Append text fields
    formData.append('firstName', data.firstName);
    formData.append('lastName', data.lastName);
    formData.append('occupation', data.occupation);
    formData.append('birthday', data.birthday);
    formData.append('phone', data.phone);
    formData.append('email', data.email);
    formData.append('state', data.state);
    formData.append('country', data.country);
    formData.append('yearsOfExperience', data.yearsOfExperience);
    formData.append('bio', data.bio);

    // Append governmentId if provided (assuming it is a File object)
    // Append governmentId if provided and is a File
    if (data.governmentId && data.governmentId instanceof File) {
      formData.append('governmentId', data.governmentId);
    }

    const url: HttpConfig = {
      url: `auth-service/users`,
      method: 'patch',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };

    request(url, onUpdateBasicInfoSuccess, setLoading, onUpdateBasicInfoError);
  };

  return { updateBasicInfo, loading };
};

export default useUpdateBasicInformation;
